<script setup>
import { inject, ref, onMounted } from 'vue'
const { isReady, logs } = inject('telegram')
const showDebug = ref(false)
onMounted(() => {
  setTimeout(() => { if (!isReady.value) showDebug.value = true }, 4000)
})
</script>

<template>
  <div v-if="!isReady" class="tg-loading-guard">
    <div class="loading-content">
      <div class="tg-loading-spinner" />
      <div v-if="showDebug" class="debug-overlay">
        <h3>Initialization Logs</h3>
        <div class="logs-container">
          <div v-for="(log, i) in logs" :key="i" class="log-line">{{ log }}</div>
        </div>
        <button class="reload-btn" @click="() => window.location.reload()">Reload Page</button>
      </div>
    </div>
  </div>
  <slot v-else />
</template>

<style scoped>
.tg-loading-guard { position: fixed; inset: 0; background: #000; display: flex; align-items: center; justify-content: center; z-index: 9999; color: #fff; font-family: monospace; }
.loading-content { display: flex; flex-direction: column; align-items: center; gap: 20px; width: 90%; max-width: 400px; }
.tg-loading-spinner { width: 32px; height: 32px; border: 2px solid rgba(255, 255, 255, 0.2); border-top-color: #fff; border-radius: 50%; animation: spin 0.8s linear infinite; }
.debug-overlay { background: rgba(30, 30, 30, 0.9); padding: 15px; border-radius: 8px; border: 1px solid #444; width: 100%; }
.debug-overlay h3 { margin-top: 0; font-size: 14px; color: #ffcc00; border-bottom: 1px solid #444; padding-bottom: 5px; }
.logs-container { max-height: 200px; overflow-y: auto; font-size: 10px; text-align: left; }
.log-line { margin-bottom: 4px; word-break: break-all; }
.reload-btn { margin-top: 10px; background: #ffcc00; color: #000; border: none; padding: 5px 10px; border-radius: 4px; font-size: 12px; cursor: pointer; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
